import React from 'react'
import { back } from 'redux-first-router'
import { runOnNextTick } from 'util/functions'
import TitleBar from './TitleBar'
import Search from './Search'

class TicketListHeader extends React.Component {
  state = {}

  componentWillReceiveProps(newProps) {
    const previousLabelSuggestions = this.props.suggestions.label
    const first = previousLabelSuggestions && previousLabelSuggestions[0]
    if (previousLabelSuggestions && (!first || !first.isLoading)) {
      this.setState({
        previousLabelSuggestionSize: previousLabelSuggestions.length,
      })
    }
  }

  render() {
    const { currentPart } = this.props
    const operator = currentPart && currentPart.operator
    const { previousLabelSuggestionSize: prevLabelSize } = this.state
    const defaultSize = operator === 'tag' ? 20 : 5
    const prevSize =
      prevLabelSize || prevLabelSize === 0 ? prevLabelSize : defaultSize

    return (
      <React.Fragment>
        <Search previousLabelSuggestionSize={prevSize} />

        <TitleBar {...this.props} />
      </React.Fragment>
    )
  }
}

export default TicketListHeader
